module.exports = __webpack_public_path__ + "img/backspace-fill.7a454733.svg";